import { render, staticRenderFns } from "./PlayerStatsTable.vue?vue&type=template&id=35916630&scoped=true&"
import script from "./PlayerStatsTable.vue?vue&type=script&lang=js&"
export * from "./PlayerStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStatsTable.vue?vue&type=style&index=0&id=35916630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35916630",
  null
  
)

export default component.exports